import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityNL extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Toegankelijkheidsverklaring - CamAPS FX</title>
                    <meta name="title" content="Toegankelijkheidsverklaring"/>
                    <meta name="description"
                          content="CamDiab zet zich in voor het bevorderen en verbeteren van de toegankelijkheid en bruikbaarheid van zijn digitale producten voor iedereen, inclusief mensen met e"/>
                    <meta property="og:locale" content="nl"/>
                    <meta name="keywords" content="toegankelijkheidsverklaring"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Toegankelijkheidsverklaring</h1>
                                <h3>Versie van 11 september 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab zet zich in voor het bevorderen en verbeteren van de toegankelijkheid en bruikbaarheid van zijn digitale producten voor iedereen, inclusief mensen met een beperking.
                                </p>
                                <h2>
                                    Conformiteitsstatus
                                </h2>
                                <p>
                                    CamDiab streeft ernaar te voldoen aan de Web Content Accessibility Guidelines (WCAG) versie 2.2, niveau AA (WCAG 2.2 AA). Deze wereldwijd erkende richtlijnen helpen webcontent toegankelijker te maken voor iedereen.
                                </p>
                                <h2>
                                    Aanvullende maatregelen ter ondersteuning van toegankelijkheid
                                </h2>
                                <p>
                                    CamDiab neemt onder andere de volgende aanvullende maatregelen om onze digitale content gebruiksvriendelijker te maken:
                                </p>
                                <ul>
                                    <li>Doorlopende toegankelijkheidstraining aanbieden aan onze medewerkers</li>
                                    <li>Formele methoden voor kwaliteitsborging van toegankelijkheid toepassen via beoordelingen door derden</li>
                                    <li>Duidelijke toegankelijkheidsdoelstellingen en verantwoordelijkheden vaststellen</li>
                                </ul>
                                <h2>
                                    Feedback
                                </h2>
                                <p>
                                    Wij verwelkomen opmerkingen over hoe we onze digitale producten voor gebruikers met een beperking kunnen verbeteren. Als u problemen ondervindt bij het bekijken van of navigeren door onze content, of content, een functie of functionaliteit opmerkt waarvan u denkt dat deze niet volledig toegankelijk is voor mensen met een beperking, neem dan contact met ons op via ons support-e-mailadres: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Wij nemen uw feedback serieus en zullen deze meenemen bij het beoordelen van manieren om aan de behoeften van al onze klanten te voldoen en bij het ontwikkelen van ons algemene toegankelijkheidsbeleid. Hoewel wij geen controle hebben over content die door externe leveranciers wordt aangeboden, moedigen wij hen sterk aan om toegankelijke en gebruiksvriendelijke content aan te bieden.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
